import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { Subscription } from 'rxjs';
@Component({
    selector: 'app-hqmaster',
    template: require('./hqmaster.component.html'),
    styles: [],
    viewProviders: [ApiService]
})
export class HqMasterComponent implements OnInit {
    static parameters = [ApiService]
    hqMasterData: any = [];
    private columnDefs;
    private rowHeight;
    api: any;
    busy: Subscription;
    columnApi: any;
    defaultColDefine;
    private gridColumnApi;

    constructor(private apiService: ApiService) {
        this.apiService = apiService
        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };
    }

    ngOnInit() {
        this.columnDefs = [
            { headerName: 'State', field: "StateName", width: 250 },
            { headerName: 'HQ', field: "HQName", width: 250 },
            {
                headerName: 'Status', field: "status"
                , cellRenderer: function (params) {
                    var eDiv = document.createElement('div');
                    eDiv.innerHTML = params.data.status ? `Enable` : `Disable`;
                    return eDiv;
                }, width: 100
            },
            // { headerName: 'RSM', field: "RSM" },
            // { headerName: 'ZSM', field: "ZSM" },
            // { headerName: 'Status', field: "status" },
            // { headerName: 'State', field: "StateName" },
            // { headerName: 'Alloted Strength', field: "" },
            // { headerName: 'Allocated Stockist', field: "" },
            // {
            //   headerName: 'Action', width: 90, pinned: 'right', cellRenderer: function (params) {
            //     var eDiv = document.createElement('div');
            //     eDiv.innerHTML = `
            //     <div class="grid_actions">
            //       <span class="viewBtn grid_actions_item"><i class="icon-view"></i></span>

            //       <span class="deleteBtn grid_actions_item"><i class="icon-delete"></i></span>

            //     </div>
            //   `;
            //     var viewButton = eDiv.querySelectorAll('.viewBtn')[0];
            //     var deleteBtn = eDiv.querySelectorAll('.deleteBtn')[0];
            //     viewButton.addEventListener('click', function () {

            //     });

            //     deleteBtn.addEventListener('click', function () {

            //     })
            //     return eDiv
            // }
            // },
        ];
        this.hqMasterData = [];
        this.getHqMaster();
    }

    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        //this.api.hideOverlay();
    }

    onBtnExport() {
        this.api.exportDataAsCsv({ fileName: 'hqmaster' });
    }

    sizeToFit(skipHeader) {
        var allColumnIds = [];
        this.gridColumnApi.getAllColumns().forEach(function (column) {
            allColumnIds.push(column.colId);
        });
        this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    }

    getHqMaster() {
        // this.api.showLoadingOverlay();
        this.busy = this.apiService.getHQMasters().subscribe((res: any) => {
            this.hqMasterData = res.data;
            // this.api.showNoRowsOverlay();
        })
    }
}